import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import TextInput from '../../../shared/inputs/TextInput';
import Button from '../../../shared/buttons/Button';
import {
  postTeamChartmetaUsingTeamidAndChartid,
  postTeamChartdivisionUsingTeamidAndChartid,
} from '../../../api/cloudApiGenerated';
import Select from '../../../shared/inputs/Select';

class ThemeModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.closeMetaDataModal = this.closeMetaDataModal.bind(this);
    this.changeMetaData = this.changeMetaData.bind(this);
    this.updateState = this.updateState.bind(this);
    this.handleDivisionChange = this.handleDivisionChange.bind(this);

    this.state = {
      theme: props.theme,
      selectedDivision: false,
      showMetaDataModal: false,
      form: {
        name: {
          value: props.theme.name,
          error: false,
        },
        division: false,
      },
    };
  }

  /*
  componentWillReceiveProps(newProps) {
    const oldTeam = this.state.team;
    const newTeam = newProps.team;

    if (!oldTeam || (newTeam && newTeam.id !== oldTeam.id)) {
      this.setState({ team: newTeam });
    }
  }*/

  openMetaDataModal() {
    const form = this.state.form;
    const { theme, divisions } = this.props;
    const activeDivision = divisions.find((div) => div.id === theme.division);
    form.name.value = theme.name;
    form.division = activeDivision;

    this.setState({
      showMetaDataModal: true,
      selectValue: (theme.private || '').toString(),
      form,
    });
  }

  closeMetaDataModal() {
    this.setState({ showMetaDataModal: false });
  }

  changeMetaData() {
    const { divisions, refreshThemes, snackBar, team } = this.props;
    const { form, theme } = this.state;
    const promises = [];

    promises.push(postTeamChartmetaUsingTeamidAndChartid(team.id, theme.id, { name: form.name.value }));

    if (form.division && form.division.id !== theme.division) {
      promises.push(postTeamChartdivisionUsingTeamidAndChartid(team.id, theme.id, { division: form.division.id }));
    }

    Promise.all(promises)
      .then(() => {
        refreshThemes();
        snackBar('Details updated');
        this.closeMetaDataModal();
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  updateState(event) {
    const field = event.target.name;
    let form = this.state.form;
    form[field].value = event.target.value;
    form[field].error = false;
    return this.setState({ form });
  }

  handleDivisionChange(newDivision) {
    let form = this.state.form;
    form.division = newDivision;
    return this.setState({ form });
  }

  render() {
    const { divisions = [] } = this.props;
    let form = this.state.form;

    return (
      <Modal
        className="hc-modal-content"
        overlayClassName="hc-modal-overlay"
        appElement={document.querySelector('.page-container')}
        isOpen={this.state.showMetaDataModal}
        contentLabel="Change Theme details"
        onRequestClose={this.closeMetaDataModal}
      >
        <h3 className="chart-modal-header">Change theme details</h3>
        <div className="row row-centered">
          <form role="form">
            <label htmlFor="name">Name:</label>
            <TextInput
              name="name"
              onChange={this.updateState}
              placeholder="Name"
              value={form.name.value}
              autoFocus={true}
            />
            <label>Division: </label>
            <Select
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              name="division"
              className={'form-group'}
              placeholder={'Select Division'}
              options={divisions}
              value={form.division}
              onChange={this.handleDivisionChange}
              clearable={false}
            />
            <Button buttonClass=" " buttonText="Save" onClick={this.changeMetaData} />
            <Button buttonClass="btn-secondary" buttonText="Cancel" onClick={this.closeMetaDataModal} />
          </form>
        </div>
      </Modal>
    );
  }
}

ThemeModal.propTypes = {
  theme: PropTypes.object.isRequired,
  team: PropTypes.object,
  update: PropTypes.func,
  refreshThemes: PropTypes.func,
  snackBar: PropTypes.func,
};

export default ThemeModal;
